import { lazy } from 'react';
const PaymentAcknowledgement = lazy(() => import('./paymentAcknowledgement'));

const paymentAcknowledgementRoutes = [
  {
    path: '/payment-acknowledgement',
    component: PaymentAcknowledgement
  }
];

export default paymentAcknowledgementRoutes;
